import type React from 'react';
import LoadingSvg from '../svg/Loading';
import './style.scss';

export const Loading: React.FC<{
  variant?: 'screen' | 'parent' | 'static';
  size?: 'xs' | 'sm' | 'md' | 'lg';
  className?: string;
  style?: React.CSSProperties;
  transparent?: boolean;
  label?: string | React.ReactNode;
  color?: 'primary' | 'secondary' | 'danger' | 'warn' | 'info' | 'success';
}> = ({ variant, size, className, style, transparent, label, color }) => {
  let position = 'fixed';
  if (variant === 'parent') position = 'absolute';
  else if (variant === 'static') position = 'static';

  return (
    <div
      className={`ui-loading ui-loading-${size || 'size'} ui-loading-${color ?? 'default'} ui-loading-${position} ${transparent ? ' ui-loading-no-overlay' : ''}${className ? ` ${className}` : ''}`}
      style={{
        left: variant === 'parent' || variant === 'static' ? 0 : undefined,
        ...style,
      }}
    >
      <LoadingSvg />
      {label && <div className="ui-loading-label">{label}</div>}
    </div>
  );
};
